import { render, staticRenderFns } from "./MultiEndpointRateLimitNotification.vue?vue&type=template&id=266447c6&scoped=true"
import script from "./MultiEndpointRateLimitNotification.vue?vue&type=script&lang=js"
export * from "./MultiEndpointRateLimitNotification.vue?vue&type=script&lang=js"
import style0 from "./MultiEndpointRateLimitNotification.vue?vue&type=style&index=0&id=266447c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266447c6",
  null
  
)

export default component.exports